import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import EntryGrid from "./components/EntryGrid";
import CompareSection from "./components/CompareSection";
import TopicWall from "./components/TopicWall";
import ExclusiveBlocks from "./components/ExclusiveBlocks";
import TrustStats from "./components/TrustStats";
import CtaBand from "./components/CtaBand";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <EntryGrid />
        <CompareSection />
        <TopicWall />
        <ExclusiveBlocks />
        <TrustStats />
        <CtaBand />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}